<template>
  <div>
    <h5 class="mb-4">
      <b>CMS</b>
    </h5>

    <!-- Login background image -->
    <FileUploader
      id="LoginImageBackground"
      :enable-crop-on-uploader="false"
      :max-files="1"
      :uploader-info="loginBackgroundConfig.uploaderInfo"
      :extensions="loginBackgroundConfig.extensions"
      :accept-types="loginBackgroundConfig.acceptTypes"
      :height="loginBackgroundConfig.height"
      :width="loginBackgroundConfig.width"
      :medias="form.background"
    />

    <!-- Logo colorida -->
    <FileUploader
      id="coloredLogo"
      :max-files="1"
      :uploader-info="coloredLogoConfig.uploaderInfo"
      :extensions="coloredLogoConfig.extensions"
      :accept-types="coloredLogoConfig.acceptTypes"
      :max-height="coloredLogoConfig.maxHeight"
      :max-width="coloredLogoConfig.maxWidth"
      :medias="form.coloredLogo"
    />

    <!-- Logo branca -->
    <FileUploader
      id="coloredWhite"
      :max-files="1"
      :uploader-info="whiteLogoConfig.uploaderInfo"
      :extensions="whiteLogoConfig.extensions"
      :accept-types="whiteLogoConfig.acceptTypes"
      :max-height="whiteLogoConfig.maxHeight"
      :max-width="whiteLogoConfig.maxWidth"
      :medias="form.whiteLogo"
    />

    <!-- Logo branca reduzida -->
    <FileUploader
      id="coloredWhiteReduced"
      :max-files="1"
      :uploader-info="whiteLogoReducedConfig.uploaderInfo"
      :extensions="whiteLogoReducedConfig.extensions"
      :accept-types="whiteLogoReducedConfig.acceptTypes"
      :max-height="whiteLogoReducedConfig.maxHeight"
      :max-width="whiteLogoReducedConfig.maxWidth"
      :medias="form.whiteLogoReduced"
    />

    <!-- Actions -->
    <CRow>
      <CCol
        lg="12"
        class="d-flex justify-content-end align-items-center mt-5"
      >
        <a
          href="javascript:void(0)"
          class="mr-3"
          @click="resetForm"
        >Limpar Alterações</a>
        <CButton
          color="success"
          :disabled="processing"
          @click="send"
        >
          {{ processing ? 'Salvando...' : 'Salvar' }}
        </CButton>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import FileUploader from '@/components/ui/Fileuploader'
import { cloneDeep } from 'lodash'
import SettingsService from '@/services/settings.service'

export default {
  components: {
    FileUploader
  },

  data() {
    return {
      loginBackgroundConfig: {
        uploaderInfo: {
          label: 'Background da tela de login',
          description: '(Formato JPG/PNG)'
        },
        extensions: 'jpg,jpeg,png',
        acceptTypes: 'image/png,image/jpeg',
        width: 1920,
        height: 1080
      },

      coloredLogoConfig: {
        uploaderInfo: {
          label: 'Logo colorida',
          description: '(Formato SVG)'
        },
        extensions: 'svg',
        acceptTypes: 'image/svg+xml',
        maxHeight: 55,
        maxWidth: 250
      },

      whiteLogoConfig: {
        uploaderInfo: {
          label: 'Logo branca ',
          description: '(Formato SVG)'
        },
        extensions: 'svg',
        acceptTypes: 'image/svg+xml',
        maxHeight: 55,
        maxWidth: 250
      },

      whiteLogoReducedConfig: {
        uploaderInfo: {
          label: 'Logo branca reduzida ',
          description: '(Formato SVG)'
        },
        extensions: 'svg',
        acceptTypes: 'image/svg+xml',
        maxHeight: 55,
        maxWidth: 250
      },

      settings: {
        background: [],
        coloredLogo: [],
        whiteLogo: [],
        whiteLogoReduced: []
      },

      form: {},
      processing: false
    }
  },

  created() {
    this.getSettings()
  },

  methods: {
    async getSettings() {
      const data = await SettingsService.listAllMedias()
      this.form = { ...this.settings, ...data }
      this.settings = cloneDeep(this.form)
    },

    resetForm() {
      this.form = cloneDeep(this.settings)
    },

    async send() {
      this.processing = true

      const data = {}

      data.background =
        this.form.background.length > 0 && this.form.background[0].id
      data.coloredLogo =
        this.form.coloredLogo.length > 0 && this.form.coloredLogo[0].id
      data.whiteLogo =
        this.form.whiteLogo.length > 0 && this.form.whiteLogo[0].id
      data.whiteLogoReduced =
        this.form.whiteLogoReduced.length > 0 &&
        this.form.whiteLogoReduced[0].id

      const response = await SettingsService.setSettingsMedia(data)

      if (response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Configurações salvas com sucesso'
        })
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Erro ao salvar as configurações, tente novamente mais tarde.'
        })
      }

      await this.getSettings()

      this.processing = false
    }
  }
}
</script>
